import { Button, Typography } from '@/components';
import { styledTextAsObj } from '@/components/Typography/Typography.styles';
import { TextStyles } from '@/constants';
import ErrorSvgIcon from 'public/images/icons/error.svg';
import styled from 'styled-components';

export const Title = styled(Typography).attrs({
  variant: TextStyles['Heading 2'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,

  [`${theme.mediaBreakpointUp.lg}`]: {
    ...styledTextAsObj[TextStyles['Heading 1']],
  },
}));

export const DeleteAccountWrapper = styled.div(({ theme }) => ({
  background: theme.colors.highEmphasisWhite,
}));

export const DeleteAccountContent = styled.div(({ theme }) => ({
  padding: theme.spacing[20],
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  background: theme.colors.highEmphasisWhite,

  [`${theme.mediaBreakpointUp.lg}`]: {
    maxWidth: 800,
    padding: `${theme.spacing[40]} 0`,
  },
}));

export const WarningBox = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing[8],
  background: theme.colors.surface02,
  padding: theme.spacing[16],
  marginBlock: theme.spacing[20],
  borderRadius: 8,

  [`${theme.mediaBreakpointUp.lg}`]: {
    marginBlock: theme.spacing[24],
  },
}));

export const WarningIcon = styled(ErrorSvgIcon)(({ theme }) => ({
  width: theme.spacing[20],
  height: theme.spacing[20],
  flex: 'none',

  path: {
    fill: theme.colors.darkError,
  },
}));

export const Text = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
  wordBreak: 'break-word',

  [`${theme.mediaBreakpointUp.lg}`]: {
    ...styledTextAsObj[TextStyles['Body Text Large']],
  },
}));

export const ConsequencesList = styled.ul(({ theme }) => ({
  ...styledTextAsObj[TextStyles['Body Text Small']],
  color: theme.colors.highEmphasisBlack,
  wordBreak: 'break-word',
  paddingLeft: theme.spacing[22],
  margin: 0,

  [`${theme.mediaBreakpointUp.lg}`]: {
    ...styledTextAsObj[TextStyles['Body Text Large']],
    paddingLeft: theme.spacing[24],
  },
}));

export const Description = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],
}));

export const ButtonGroup = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column-reverse',
  justifyContent: 'center',
  alignItems: 'stretch',
  marginTop: theme.spacing[24],
  gap: theme.spacing[8],

  '> button, > a': {
    flex: 1,
    width: 'auto',
    height: 'auto',
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    flexDirection: 'row',
  },
}));

export const ErrorText = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  marginTop: theme.spacing[12],
  color: theme.colors.darkError,
}));

export const DeleteButtonWrapper = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing[24],

  [`${theme.mediaBreakpointUp.lg}`]: {
    marginTop: theme.spacing[40],
  },
}));
